export default import.meta.ROLLUP_FILE_URL_Dy_FV7qn;